import classNames from 'classnames';
import React, { useContext, useMemo } from 'react';

import { HeaderAccountFlyoutProps } from '@zooplus/header-account-flyout';
import { LayoutContainer } from '@zooplus/ui-components';

import AppContext from '../../context';
import { SECURITY_ICONS_ID } from '../../utils/constants';
import { SentryBoundary } from '../../utils/SentryBoundary';
import { CartNavButton } from '../CartNavButton/CartNavButton';
import getHeaderAccountFlyout from '../HeaderAccountFlyout/HeaderAccountFlyoutWrapper';
import PointsBalance from '../PointsBalance/PointsBalanceWrapper';
import DesktopSearchBar from '../SearchBar/DesktopSearchBar';

import BrandLogo from './BrandLogo';
import styles from './MiddleBar.module.scss';
import MobileBurgerButton from './MobileBurgerButton';

export const LOGO_ID = 'srh-logo';
export const BURGER_MIDDLE_BAR_BUTTON_ID = 'srh-burger-mbbutton';

export default function MiddleBar(): React.JSX.Element {
    const {
        brand,
        bundle,
        domain,
        vendorAssetsURL,
        deployStage,
        securityIconsHTML,
        showCart,
        showCategories,
        showSearch,
        translations,
        translationsLocale,
        isNextJS,
        zooClubComponentEnabled,
        uiBitiba20AnniversaryLogoEnabled,
    } = useContext(AppContext);

    const HeaderAccountFlyout = useMemo(
        () => getHeaderAccountFlyout(isNextJS),
        [],
    );

    return (
        <LayoutContainer variant="default" data-zta="middle-bar">
            <div className={styles.middleBar}>
                {showCategories && (
                    <MobileBurgerButton
                        id={BURGER_MIDDLE_BAR_BUTTON_ID}
                        label={translations.get(
                            'shop.header.accessible.catalog.menu',
                        )}
                    />
                )}

                <BrandLogo
                    id={LOGO_ID}
                    vendorAssetsURL={vendorAssetsURL}
                    deployStage={deployStage}
                    bundle={bundle}
                    brand={brand}
                    specialLogo={uiBitiba20AnniversaryLogoEnabled}
                    alt={translations.get(
                        'shop.header.accessible.logo.alternative',
                    )}
                />

                <div className={styles.desktopSearchBarWrapper}>
                    {showSearch && <DesktopSearchBar />}
                </div>

                {zooClubComponentEnabled && (
                    <div className={styles.pointsBalanceWrapper}>
                        <PointsBalance />
                    </div>
                )}

                <SentryBoundary componentId="mobile-header-account-flyout">
                    <div className={styles.mobileHeaderAccountFlyoutContainer}>
                        <HeaderAccountFlyout
                            locale={
                                translationsLocale as HeaderAccountFlyoutProps['locale']
                            }
                            bundle={
                                bundle as HeaderAccountFlyoutProps['bundle']
                            }
                            domain={
                                domain as HeaderAccountFlyoutProps['domain']
                            }
                            hasBonusPoints={zooClubComponentEnabled}
                            onFlyoutClick={() => {}}
                        />
                    </div>
                </SentryBoundary>
                {showCart && <CartNavButton />}
                {securityIconsHTML && (
                    <div
                        className={classNames(styles.securityIcons, {
                            [styles.showIcons]: !showCart,
                        })}
                        data-zta="security-icons">
                        <div
                            id={SECURITY_ICONS_ID}
                            dangerouslySetInnerHTML={{
                                __html: securityIconsHTML,
                            }}
                        />
                    </div>
                )}
            </div>
        </LayoutContainer>
    );
}
